
import TimeUnit from "./TimeUnit.js";
import DateUtils from "@/utils/DateUtils.js";
import RcMonth from "./RcMonth.js";
import RcDay from "./RcDay.js";
import RcYear from "./RcYear.js";
import RcHour from "./RcHour.js";
import RcQuarterHour from "./RcQuarterHour.js";

/** An instant, mirroring com.readychek.time.RcDate. */
export default class RcDate extends TimeUnit {

  constructor(date, timeZone) {
    super(date, timeZone);
  }

  static from(time, zone) {
    return new RcDate(new Date(time), zone);
  }

  day() {
    return new RcDay(this.internalDate(), this.timeZone());
  }

  month() {
    return new RcMonth(this.internalDate(), this.timeZone());
  }

  year() {
    return new RcYear(this.internalDate(), this.timeZone());
  }

  hour() {
    return new RcHour(this.internalDate(), this.timeZone());
  }

  quarterHour() {
    return new RcQuarterHour(this.internalDate(), this.timeZone());
  }

  value() {
    return this.time();
  }

  /** The day of the week, 0 for Sunday. */
  name() {
    return this.dayOfWeek();
  }

  /** The quarter of the day this instant falls in, 0 through 95. */
  timeId() {
    const quarter = this.quarterHour();
    return TimeUnit.newTimeId(quarter.hour().value(), quarter.value());
  }

  /**
   * Steps back whole days. The java RcDate reads this argument as milliseconds; on the web
   * client it has always meant days and the callers rely on that, so the millisecond and
   * minute forms are spelled out separately below.
   */
  minus(days) {
    return new RcDate(new Date(this.time() - DateUtils.days(days)), this.timeZone());
  }

  plus(days) {
    return new RcDate(new Date(this.time() + DateUtils.days(days)), this.timeZone());
  }

  plusMillis(millis) {
    return new RcDate(new Date(this.time() + millis), this.timeZone());
  }

  minusMillis(millis) {
    return new RcDate(new Date(this.time() - millis), this.timeZone());
  }

  plusMinutes(minutes) {
    return this.plusMillis(DateUtils.minutes(minutes));
  }

  minusMinutes(minutes) {
    return this.minusMillis(DateUtils.minutes(minutes));
  }

  diff(rcDate) {
    return this.time() - rcDate.time();
  }
}
